/**
 * action types
 */
export const SET_SUBSCRIPTION_PLANS = 'SET_SUBSCRIPTION_PLANS';
export const FETCH_SUBSCRIPTION_PLANS = 'FETCH_SUBSCRIPTION_PLANS';
export const LIST_SUBSCRIPTION_PLANS = 'LIST_SUBSCRIPTION_PLANS';

export const FETCH_LOCALISED_SUBSCRIPTION_PLANS_START =
  'FETCH_LOCALISED_SUBSCRIPTION_PLANS_START';
export const FETCH_LOCALISED_SUBSCRIPTION_PLANS_SUCCESS =
  'FETCH_LOCALISED_SUBSCRIPTION_PLANS_SUCCESS';
